// Adds the opt-in curriculum filter to Create Quiz params (product/CONTRACT-UI-SLICE2.md).
// With nothing selected the params are returned untouched, so the request is exactly
// what the page sent before this feature existed.
export const withCurriculumFilter = (quizParams, rowIds, edition) => {
  const rows = [...new Set((rowIds || []).filter(Boolean))];
  if (!rows.length || !edition || !String(edition).trim()) return quizParams;
  return { ...quizParams, curriculumRowIds: rows, curriculumEdition: String(edition).trim() };
};
